import React from 'react';
import { Navigate } from 'react-router-dom';
import { getStoredUser, isNavHidden, isStudioTabHidden } from '../utils/featureAccess';

export default function StudioTabRoute({ tab, children }) {
    const user = getStoredUser();
    return isNavHidden(user, 'my-reports') || isStudioTabHidden(user, tab)
        ? <Navigate to="/my-reports" replace />
        : children;
}
